import CustomerInvoices from '../customerInvoices/customerInvoices';
export default function CustomerInvoicesTab(props) {

    const projectId = props.projectId
return (
    <div>
        <CustomerInvoices isInProject = {true} projectId = {projectId}></CustomerInvoices>
    </div>
)};